<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-info.text-white
				span.fa.fa-upload.mr-2
				| Encuesta
				button.close(@click="cerrar") &times;
			.card-body
				.form-group
					label
						b Título de la encuesta
					input.form-control(v-model="editor.Titulo")
			.card-body.bg-light
				p
					b Opciones

				.input-group.mb-2(
					v-for="(opcion, i) in editor.Opciones"
					:key="i"
				)
					.input-group-prepend
						.input-group-text {{i + 1}}
					input.form-control(v-model="editor.Opciones[i]", placeholder="Escribe el valor aquí")
					.input-group-append
						button.btn.btn-danger(@click="quitarOpcion(i)")
							span.fa.fa-trash

				button.btn.btn-sm.btn-primary.m-3(@click="nuevaOpcion")
					span.fa.fa-plus.mr-2
					| Nueva opción
			.card-footer
				button.btn.btn-primary(@click="guardar", :disabled="!encuestaValida")
					| Guardar
</template>

<script>
export default {
	props: ['encuesta'],
	data () {
		return {
			editor: {
				EncuestaID: null,
				FechaFinalizacion: null,
				Titulo: '',
				Opciones: []
			}
		}
	},
	computed: {
		encuestaValida () {
			if (this.editor.Titulo.trim() === '') {
				return false
			}

			if (this.editor.Opciones.length < 2) {
				return false
			}

			// si las opciones no son válidas...
			for (let i = 0; i < this.editor.Opciones.length; i++) {
				if (this.editor.Opciones[i].trim() === '') {
					return false
				}
			}

			return true
		}
	},
	created () {
		if (typeof this.encuesta === 'boolean') {
			console.log('Es una encuesta nueva')
			this.editor.EncuestaID = 'N' + new Date().getTime() + Math.floor(Math.random() * 1000)
			this.editor.FechaFinalizacion = null
		} else if (typeof this.encuesta === 'object') {
			// Estamos editando
			this.editor = JSON.parse(JSON.stringify(this.encuesta))
			this.editor.FechaFinalizacion = (typeof this.encuesta.FechaFinalizacion === 'string') ? new Date(this.encuesta.FechaFinalizacion) : null
		}
	},
	methods: {
		nuevaOpcion () {
			this.editor.Opciones.push('')
		},
		quitarOpcion (i) {
			this.editor.Opciones.splice(i, 1)
		},
		guardar () {
			this.$emit('updated', this.editor)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/nueva/editorEncuesta.vue